import { Injectable } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { take } from 'rxjs/operators';
import { TAppMaster } from '@monorepo/resolvers';
import { select, Store } from '@ngrx/store';
import {
  ChangeShiftId,
  LoadShifts,
  InitialiseAndFetchSessionPlans,
  FetchSessionPlans,
  CheckSessionHoursStatus,
} from './shifts.actions';
import { selectedShift, selectAllShifts, selectIsWithinWorkingHours, selectSessionTimes } from './shifts.query';
import { Observable } from 'rxjs';
import { AppMasterDBFacade } from '@monorepo/core-data';
import { SessionTimes, CurrentSession } from '@monorepo/types';
@Injectable({
  providedIn: 'root',
})
export class ShiftsFacade {
  constructor(private store: Store<TAppMaster>, private appMasterDBFacade: AppMasterDBFacade) {}

  syncShifts() {
    this.store.dispatch(new LoadShifts());
  }

  getAllShifts() {
    return this.store.pipe(select(selectAllShifts));
  }

  getSelectedShift() {
    return this.store.pipe(select(selectedShift));
  }

  changeShiftId(shiftId: string) {
    this.store.dispatch(new ChangeShiftId(shiftId));
  }

  /**
   * This function will return the current session hours status
   * it will return the session times and working hours status
   * @returns Observable<CurrentSession>
   */
  getCurrentSessionHoursStatus() {
    return combineLatest([this.getWorkingStatus(), this.store.pipe(select(selectSessionTimes))]).pipe(
      map(([isWithinWorkingHours, sessionTimes]) => {
        return {
          isWithinWorkingHours,
          sessionTimes,
        } as CurrentSession;
      }),
    );
  }

  /**
   * method to update the session times and working hours status for selected station based on cached session plans
   */
  checkAndUpdateWorkingHoursStatus() {
    this.store.dispatch(new CheckSessionHoursStatus());
  }

  /**
   * This function will initialise and fetch session plans for all the stations and calls FetchSessionPlans
   */
  initialiseAndFetchSessionPlans() {
    this.store.dispatch(new InitialiseAndFetchSessionPlans());
  }

  /**
   * This function fetches the session plans for selected station
   */
  fetchSessionPlans(fetchAllSubjects: boolean) {
    this.store.dispatch(new FetchSessionPlans(fetchAllSubjects));
  }

  /**
   * This function returns the working hours status; default is true
   * if its false then show the message & disable the actions
   * @returns Observable<boolean>
   */
  public getWorkingStatus(): Observable<boolean> {
    return this.store.pipe(select(selectIsWithinWorkingHours));
  }
}
